module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAPJJREFUSA3tlD0KwkAQhbMiWgQPEUjjHaxT5CBeIY3kIF7BUwQbewsvYCtWCgqyfisuxLDZn6CNycBjNzPvvdlM2ERR70JKWYIraIsLhdI1GOEiYHKDM3Hw7kKIqY3j00jaDHSNRlavkSb+eh0adZ7wMLrOoxvXlVzONc/zes53j3bb4B64Wkud+2hEcgYWuhi4NnXHVj2nEmAFHqBrKK3ysP4pXoeAlIMzCA2lyVvfxFRAkIJ9QCfFTU1ezhzCGGw8milO7DR0ETApgOm7qVzh0gfVMczACehQ+yzIxJeMcQJ2byS+uh7wGEkFvhXVf4/sCXKHugbvBjMCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/transctl/img/download.png
// module id = 870
// module chunks = 0